export interface FormFieldsValidationRules {
  rules: {
    [key: string]: {
      [key: string]: string | number | boolean;
    };
  };
  messages: {
    [key: string]: {
      [key: string]: string;
    };
  };
}

interface FormFieldsValidationError {
  [key: string]: string;
}

export const validators: { [key: string]: (value: string, rule: any, allValues: { [key: string]: any }) => boolean } = {
  pattern(value: string, regexp: string) {
    const pattern = new RegExp(regexp);
    const match = pattern.exec(String(value));
    return !(!match || match[0].length !== String(value).length);
  },
  required(value: string, rule: boolean) {
    return !rule || value !== '';
  },
  min(value: string, rule: number) {
    return parseFloat(value) >= rule;
  },
  max(value: string, rule: number) {
    return parseFloat(value) <= rule;
  },
  minLength(value: string, minLength: number) {
    return value.length >= minLength;
  },
  maxLength(value: string, maxLength: number) {
    return value.length <= maxLength;
  },
  equalTo(value: string, rule: string, allValues: { [key: string]: any }) {
    return value === allValues[rule];
  }
};

export function formFieldsValidation(
  values: Record<string, any>,
  { rules, messages }: FormFieldsValidationRules
): FormFieldsValidationError {
  const errors: FormFieldsValidationError = {};

  Object.entries(values).forEach(([fieldKey, fieldValue]) => {
    /* istanbul ignore else */
    if (rules[fieldKey]) {
      Object.entries(rules[fieldKey]).forEach(([ruleTitle, rule]) => {
        if (validators[ruleTitle](fieldValue, rule, values) === false) {
          errors[fieldKey] = messages[fieldKey][ruleTitle];
        }
      });
    }
  });

  return errors;
}
